// src/hooks/useStickyFilter.js
//
// Pairs with the `.k-filter-sticky` card style: the card pins to the top while
// the list scrolls under it, and `.is-stuck` (the depth cue) is applied only
// once it actually sticks.
//
//   const [sentinelRef, isStuck] = useStickyFilter();
//   <div ref={sentinelRef} aria-hidden="true" style={{ height: 1, marginBottom: -1 }} />
//   <div className={`k-card k-filter-sticky ${isStuck ? 'is-stuck' : ''}`}>…</div>
import { useCallback, useEffect, useRef, useState } from 'react';

export const useStickyFilter = () => {
  const [isStuck, setIsStuck] = useState(false);
  const observerRef = useRef(null);

  // Callback ref: the sentinel often only exists after loading/error states
  // clear, so attach the observer whenever the node appears rather than on mount.
  const sentinelRef = useCallback(node => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node && typeof IntersectionObserver !== 'undefined') {
      observerRef.current = new IntersectionObserver(
        ([entry]) => setIsStuck(!entry.isIntersecting),
        { threshold: 0 }
      );
      observerRef.current.observe(node);
    }
  }, []);

  useEffect(() => () => observerRef.current?.disconnect(), []);

  return [sentinelRef, isStuck];
};
